import {
  actions,
  createFlowSelectionAsync,
  editFlowSelectionAsync,
  getFlowSelectionsDatatableAsync,
  getFlowSelectionByIdAsync,
  changePublishStateAsync,
} from './slices';

export const FlowSelectionsActions = {
  ...actions,
  createFlowSelectionAsync,
  editFlowSelectionAsync,
  getFlowSelectionsDatatableAsync,
  getFlowSelectionByIdAsync,
  changePublishStateAsync,
};
